import { Loading } from 'element-ui';
let loadingCount = 0;
let loading;
const startLoading = () => {
    loading = Loading.service({
        lock: false,
        text: 'Loading……',
        background: 'rgba(0, 0, 0, 0.7)',
        body: true
    });
};

const endLoading = () => {
    loading.close();
};

const showLoading = () => {
    if (loadingCount === 0) {
        startLoading();
    }
    loadingCount += 1;
};

const hideLoading = () => {
    if (loadingCount <= 0) {
        return;
    }
    loadingCount -= 1;
    if (loadingCount === 0) {
        endLoading();
    }
};
export default { showLoading, hideLoading };



// WEBPACK FOOTER //
// ./src/js/loading.js